/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface DocumentConfigurationScope extends angular.IScope {
        configs: Wars.Domain.Model.Documents.DocumentConfiguration[];
        systemDocumentConfig: Wars.Domain.Model.Documents.SystemDocumentConfiguration;
        selectedConfig: Wars.Domain.Model.Documents.DocumentConfiguration;
        processConfigId: string;
        addDocumentConfig(): void;
        edit(documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration): void;
        delete(documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration): void;
    }

    export class DocumentConfigurationController implements IController {

        constructor(
            private scope: DocumentConfigurationScope,
            $routeParams: angular.route.IRouteParamsService,
            private documentService: services.DocumentService,
            private deleteService: services.DeleteService,
            private systemLevelService: services.SystemLevelService)
        {

            this.scope.processConfigId = $routeParams["id"];

            if (this.scope.processConfigId) {
                this.documentService.getDocumentConfigs(this.scope.processConfigId).then(
                    (configs) => {
                        this.scope.configs = configs;
                    });

                this.systemLevelService.getSystemLevelDocumentConfiguration().then(
                    (sysLevel) => {
                        this.scope.systemDocumentConfig = sysLevel.systemDocumentConfiguration;
                    });
            } else {
                this.systemLevelService.getSystemLevelDocumentConfiguration().then(
                    (sysLevel) => {
                        this.scope.systemDocumentConfig = sysLevel.systemDocumentConfiguration;
                        this.scope.configs = sysLevel.myDocumentConfigurations;
                    });
            }
            

            this.scope.addDocumentConfig = () => this.addDocumentConfig();
            this.scope.edit = (documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration) => this.edit(documentConfiguration);
            this.scope.delete = (documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration) => this.delete(documentConfiguration);
        }

        private addDocumentConfig(): void {
            var docConfig = this.documentService.createDocumentConfig();
            if (this.scope.processConfigId) {
                docConfig.processConfiguration_id = this.scope.processConfigId;
            } else {
                docConfig.systemLevel_id = this.scope.systemDocumentConfig.systemLevel_id;
            }
            this.scope.configs.push(docConfig);
            this.scope.selectedConfig = docConfig;
            this.documentService.saveAllChanges();
        }

        private edit(documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration): void {
            this.scope.selectedConfig = documentConfiguration;
        }

        private delete(documentConfiguration: Wars.Domain.Model.Documents.DocumentConfiguration): void {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "DocumentConfiguration",
                documentConfiguration.id,
                "Document Configuration",
                () => {
                    this.scope.configs.remove(documentConfiguration);
                    this.scope.selectedConfig = undefined;
                });
        }
    }
}
warsApp.registerController("DocumentConfigurationController", ["$scope", "$routeParams", "documentService", "deleteService", "systemLevelService" ]
);